module.exports = __webpack_public_path__ + "img/hr-pump-west-liquid.b022367d.png";